import React from 'react';
import classNames from "classnames";
import { BadgeProps } from "./PropsType";

export default function Badge(props: BadgeProps) {
  const {
    className,
    children,
    count = 0,
    fixed,
    dot,
    notify,
    max = 99,
    prefixCls = 'bm-Badge',
    shape,
    status = 'error',
    text,
    ...other
  }: any = props;
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-sr-only`]: !children,
      [`${prefixCls}-fixed`]: fixed,
    },
    className
  );
  const supStyleClass = classNames(
    `${prefixCls}-count`,
    {
      [`${prefixCls}-dot`]: dot,
      [`${prefixCls}-notify`]: notify,
      [`${prefixCls}-circle`]: shape === "circle",
    },
    `${prefixCls}-${status}`
  );
  const currentCount: any = count > max ? max + "+" : count;

  return (
    <span className={styleClass} {...other}>
      {children}
      <span className={supStyleClass}>
        {text ? (
          text
        ) : (
          <span className={`${prefixCls}-count-inner`}>
            {dot || count === 0 ? null : currentCount}
          </span>
        )}
      </span>
    </span>
  );
}
